import React from 'react';
import { Select } from 'antd';
import services from "../../services";
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'

const { Option } = Select;

class AcceptMovement extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         popUpForm: '',
         data: [],
         idEntidade: 0,
         idContaCorrente: 0,
         idContaCorrenteMovimento: 0,
         idTipoMovimento: 0,
         valorOp: 0,
         instalacaoVinica: "",
         tipoConta: "",
         produto: "",
         quantidade: "",
         tipoMovimento: "",
         entidade: "",
         instalacoesVinicasDestino: [],
         idInstalacaoVinicaDestino: 0,
         idContaCorrenteDestino: 0,
         contasCorrentesDestino: [],
         contasExecuted: 0
      }
   }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

   componentDidMount() {

      (async () => {
         const filter = {
           Nome: this.props.entidade
         }
         const entidade = await services.apiCall.requestApi(
           "Entidades/ViewEntidades",
           filter,
           "get"
         );
            (async () => {
               const filter = {
               //CodEntidade: +entidade[0].codEntidade
               }
               const instalacoesVinicasDestino = await services.apiCall.requestApi(
               "InstalacaoVinica/ViewInstalacoesVinicasEntidade",
               filter,
               "get"
               )
               this.setState({ instalacoesVinicasDestino: instalacoesVinicasDestino })
            })();
            console.log("entidade");
            console.log(entidade);
        // this.setState({ entidade: entidade[0].nome, idEntidade: entidade[0].codEntidade })
       })();

      this.setState({
         idEntidade: this.props.idEntidade,
         instalacaoVinica: this.props.instalacaoVinica,
         tipoConta: this.props.tipoConta,
         produto: this.props.produto,
         quantidade: this.props.quantidade,
         tipoMovimento: this.props.tipoMovimento,
         idContaCorrente: this.props.idContaCorrente,
         idContaCorrenteMovimento: this.props.idContaCorrenteMovimento,
         idTipoMovimento: this.props.idTipoMovimento,
         valorOp: this.props.qtdNum
      });
   }

   // componentDidUpdate(prevProps) {

   // }

   handleFechar = () => {
      $(".left-popup").trigger('click');
      window.location.reload(false);
   }

   handleChangeInstalacao = (e) => {
      this.setState({ idInstalacaoVinicaDestino: e });

      //obter o IDTipoFormulario
      const filter = {
         IDTipoMovimento: this.props.idTipoMovimento
      };

      (async () => {
         const tipoFormulario = await services.apiCall.requestApi(
            "RegrasMovimento/ViewTipoFormularioTipoMovimento",
            filter,
            "get"
         );

         console.log("tipoFormulario");
         console.log(tipoFormulario);

         // vendas
         if (tipoFormulario[0].idTipoFormulario == 2){
            (async () => {
               const filter = {
                  IDContaCorrenteOrigem: this.state.idContaCorrente,
                  IDInstalacaoVinicaDestino: e
               }
               const contasCorrentesDestino = await services.apiCall.requestApi(
                  "ContaCorrente/GetContasVendasFromIV",
                  filter,
                  "get"
               );
               
               this.setState({ contasCorrentesDestino: contasCorrentesDestino, contasExecuted: 1 })
            })();
         }
         // cedencias
         else if (tipoFormulario[0].idTipoFormulario == 3){
            (async () => {
               const filter = {
                  IDContaCorrenteOrigem: this.state.idContaCorrente,
                  IDInstalacaoVinicaDestino: e
               }
               const contasCorrentesDestino = await services.apiCall.requestApi(
                  "ContaCorrente/GetContasCedenciasFromIV",
                  filter,
                  "get"
               );
               
               this.setState({ contasCorrentesDestino: contasCorrentesDestino, contasExecuted: 1 })
            })();
         }

      })();

         
 
   }

   handleChangeConta = (e) => {
      this.setState({ idContaCorrenteDestino: e });
   }

   handleSubmit = async (e) => {
      e.preventDefault()
      
      ;(async () => {
         
         //const query = queryString.parse(this.props.location.search);

         const params = {
            IDContaCorrente: +this.state.idContaCorrente,
            IDContaCorrenteMovimentoOrg: +this.state.idContaCorrenteMovimento,
            IDTipoMovimento: +this.state.idTipoMovimento,
            Quantidade: +this.state.valorOp,
            LoggedUser: window.localStorage.getItem('username'),
            IDEntidadeDestino: +this.state.idEntidade,
            IDInstalacaoVinicaDestino: +this.state.idInstalacaoVinicaDestino,
            IDContaCorrenteDestino: +this.state.idContaCorrenteDestino
         }

         console.log("SEND PARAMS");
         console.log(params);

         const response = await services.apiCall.requestApi(
            "ContaCorrente/AceitarMovimento",
            params,
            "post"
         )
         if(response){
            this.handleFechar()
         }
         else{
            this.handleFechar()
         }
      
      })()
   }

   render() {
      return (
         <div className="modal-content">
            <div className="modal-header">
               <h4 className="modal-title pl-0">Aceitar Movimento</h4>
               <Button onClick={() => this.handleFechar()} primary={true} className="remoove btn-ivdp-primary cursor-pointer mr-2">Fechar</Button>
            </div>
            <div className="modal-body">
               <div className="form-group position-relative">
                  <h5>Origem:</h5>
                  <div className="tab-section">
                     <div className="row">
                        <div className="col-12">
                           <div className="innerBox">
                              <div className="row no-gutter">
                                 <div className="col-2">
                                    <p>Instalação Vínica</p>
                                    <p className="font-weight-bold">{this.state.instalacaoVinica}</p>
                                 </div>
                                 <div className="col-2">
                                    <p>Tipo de Conta</p>
                                    <p className="font-weight-bold">{this.state.tipoConta}</p>
                                 </div>
                                 <div className="col-2">
                                    <p>Produto</p>
                                    <p className="font-weight-bold">{this.state.produto}</p>
                                 </div>
                                 <div className="col-2">
                                    <p>Tipo de Movimento</p>
                                    <p className="font-weight-bold">{this.state.tipoMovimento}</p>
                                 </div>
                                 <div className="col-2">
                                    <p>Quantidade (Litros)</p>
                                    <p className="font-weight-bold">{this.state.quantidade}</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="form-group position-relative">
                  <h5>Destino:</h5>
                  <div className="tab-section">
                     <div className="row">
                        <div className="col-12">
                           <div className="innerBox">
                              <div className="row no-gutter">
                                 <div className="col">
                                    <p>Entidade</p>
                                    <p className="font-weight-bold">{this.state.entidade || "nd"}</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="input-box active-grey">
                     <span>Instalação vínica destino</span>
                     <Select
                        optionFilterProp="children"
                        placeholder="Selecione a instalação vínica destino"
                        className="mov-Ent-Select"
                        onChange={(e) => this.handleChangeInstalacao(e)}
                        style={{ width: "100%" }}
                     >
                        <Option disabled >Selecione a instalação vínica destino</Option>
                        {(this.state.instalacoesVinicasDestino && !!this.state.instalacoesVinicasDestino.length) && this.state.instalacoesVinicasDestino.map((item, index) => (
                           <Option key={index} value={item.idInstalacaoVinica}>{item.instalacaoVinica}</Option>
                        ))}
                     </Select>
                  </div>
                  {this.state.contasCorrentesDestino.length > 0 && (
                     <>
                        <div className="input-box active-grey">
                           <span>Conta corrente destino</span>
                           <Select
                              optionFilterProp="children"
                              placeholder="Selecione a conta corrente destino"
                              className="mov-Ent-Select"
                              onChange={(e) => this.handleChangeConta(e)}
                              style={{ width: "100%" }}
                           >
                              <Option disabled >Selecione a conta corrente destino</Option>
                              {(this.state.contasCorrentesDestino && !!this.state.contasCorrentesDestino.length) && this.state.contasCorrentesDestino.map((item, index) => (
                                 <Option key={index} value={item.idContaCorrente}>{item.produto} - {item.tipoConta} - {item.cor} - Ano {item.anoProduto} - Saldo {item.saldo}</Option>
                              ))}
                           </Select>
                        </div>
                     </>
                  )}
                  {this.state.contasCorrentesDestino.length === 0 && this.state.contasExecuted === 1 && (
                     <>
                        <div className="input-box active-grey">
                           <span>Não existe conta disponível para colocar o produto. Irá ser criada uma nova conta com as mesmas características.</span>
                           
                        </div>
                     </>
                  )}
                  <div className="col-md-12 mt-4 p-0">
                     <button
                        className="k-button k-primary btn-ivdp-primary btn-sm"
                        type="submit"
                        onClick={this.handleSubmit}
                     >
                        Efetuar Operação
                     </button>
                     <button
                        className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                        onClick={() => this.handleFechar()}
                     >
                        Cancelar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      )
   }
}

export default AcceptMovement;